var _style, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLibra(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 143 143",
    style: {
      enableBackground: "new 0 0 143 143"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F5CA3D;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "BACKGROUND"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M55.5,86.9c0,2.4-1.6,4.3-3.6,4.3c2,0,3.6,1.9,3.6,4.3c0-2.4,1.6-4.3,3.6-4.3 C57.1,91.1,55.5,89.2,55.5,86.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M66.5,25.1c0,2.4-1.6,4.3-3.6,4.3c2,0,3.6,1.9,3.6,4.3c0-2.4,1.6-4.3,3.6-4.3 C68.1,29.4,66.5,27.5,66.5,25.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M90.7,102.4c0,2.4-1.6,4.3-3.6,4.3c2,0,3.6,1.9,3.6,4.3c0-2.4,1.6-4.3,3.6-4.3 C92.4,106.7,90.7,104.8,90.7,102.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 45.1,
    cy: 108.4,
    r: 1.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M33.2,51.5c0,0.7-0.6,1.4-1.4,1.4c-0.7,0-1.4-0.6-1.4-1.4c0-0.7,0.6-1.3,1.4-1.3 C32.6,50.2,33.2,50.8,33.2,51.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 115.1,
    cy: 52.3,
    r: 1.4
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M40.5,91.1c7.7,0,14-6.3,14-14c0,0,0,0,0,0c0-0.1,0-0.1,0-0.2c0,0,0-0.1,0-0.1c0,0,0-0.1,0-0.1 c0-0.1,0-0.1-0.1-0.2c0,0,0,0,0,0L43.2,51.5H63v62.9H40.5c-1,0-1.7,0.8-1.7,1.7c0,1,0.8,1.7,1.7,1.7h24.2h12.1h24.2 c1,0,1.7-0.8,1.7-1.7c0-1-0.8-1.7-1.7-1.7H78.6V51.5h19.8L87.3,76.4c0,0,0,0,0,0c0,0.1,0,0.1-0.1,0.2c0,0,0,0.1,0,0.1 c0,0,0,0.1,0,0.1c0,0.1,0,0.1,0,0.2c0,0,0,0,0,0c0,7.7,6.3,14,14,14s14-6.3,14-14c0,0,0,0,0,0c0-0.1,0-0.1,0-0.2 c0,0,0-0.1,0-0.1c0,0,0-0.1,0-0.1c0-0.1,0-0.1-0.1-0.2c0,0,0,0,0,0l-12.2-27.3c0,0,0,0,0,0l0,0c0,0,0,0,0,0 c-0.1-0.1-0.1-0.2-0.2-0.3c0,0,0-0.1-0.1-0.1c-0.1-0.1-0.2-0.2-0.3-0.3c0,0,0,0,0,0c-0.1-0.1-0.2-0.1-0.4-0.2c0,0-0.1,0-0.1,0 c-0.1,0-0.3-0.1-0.4-0.1H40.5c-0.2,0-0.3,0-0.4,0.1c0,0-0.1,0-0.1,0c-0.1,0-0.2,0.1-0.4,0.2c0,0,0,0,0,0 c-0.1,0.1-0.2,0.2-0.3,0.3c0,0,0,0.1-0.1,0.1C39.1,48.8,39,48.9,39,49c0,0,0,0,0,0l0,0c0,0,0,0,0,0L26.7,76.4c0,0,0,0,0,0 c0,0.1,0,0.1-0.1,0.2c0,0,0,0.1,0,0.1c0,0,0,0.1,0,0.1c0,0.1,0,0.1,0,0.2c0,0,0,0,0,0C26.6,84.8,32.8,91.1,40.5,91.1z  M101.1,87.6c-5.2,0-9.5-3.8-10.4-8.8h20.7C110.6,83.8,106.3,87.6,101.1,87.6z M110.7,75.4H91.5l9.6-21.4L110.7,75.4z  M66.5,51.8h8.7v62.6h-8.7V51.8z M40.5,54l9.6,21.4H31L40.5,54z M50.9,78.8c-0.8,5-5.2,8.8-10.4,8.8c-5.2,0-9.5-3.8-10.4-8.8 H50.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M40.5,35.8c-1,0-1.7,0.8-1.7,1.7c0,1,0.8,1.7,1.7,1.7h60.6c1,0,1.7-0.8,1.7-1.7c0-1-0.8-1.7-1.7-1.7H40.5z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLibra);
export default __webpack_public_path__ + "static/media/Libra.b183261b0df4ee49746f7f65871f8258.svg";
export { ForwardRef as ReactComponent };